import React from "react";

import { ICoordinate } from "shared/types";
import { FullScreen } from "shared/assets/icons";
import { OpenMapButton, MapContainer, StaticImage, MapContainerProps } from "./styles";
import { copy } from "shared/assets";
import { IconButton } from "shared/components";

interface StaticMapProps extends MapContainerProps {
  coordinates: ICoordinate;
  image?: string | null;
  alt: string;
  showOpenButton?: boolean;
}

export const StaticMap: React.FC<StaticMapProps> = ({
  image,
  alt,
  coordinates,
  showOpenButton,
  ...rest
}) => {
  if (!image) return null;
  return (
    <MapContainer {...rest}>
      {showOpenButton && (
        <OpenMapButton>
          <IconButton label={copy.a11y.openFullscreen} icon={FullScreen} size="m" />
        </OpenMapButton>
      )}
      <StaticImage src={image} alt={alt} />
    </MapContainer>
  );
};
